export default __webpack_public_path__ + "static/media/mos-coin-gold.ee929b2c.svg";